import { ListItem } from '@interstate/components/List';
import styled from 'styled-components';
import { ExpandableAreaSection } from '../../common/ExpandableArea/ExpandableAreaSection';
import type { Grid } from '@interstate/components/Grid';
import type { ComponentProps } from 'react';

interface StyledListItemProps {
    hasDelta?: boolean;
}
interface StyledExpandableAreaSection {
    $isDetailsSection?: boolean;
}
export const StyledListItem = styled(ListItem)<StyledListItemProps>`
    width: 100% !important;

    ${({ hasDelta }) => {
        return hasDelta
            ? `
            overflow: hidden;
            border-left: 4px solid #ffc20e;
            `
            : '';
    }}

    .chevron-icon {
        stroke-width: 2px;
        margin-right: 4px;
        font-size: 12px;
        color: #2b6bdd;
    }
`;

export const StyledExpandableAreaSection = styled(ExpandableAreaSection)<StyledExpandableAreaSection>`
    ${({ $isDetailsSection }) => {
        if ($isDetailsSection) {
            return `
            cursor: unset;
            border-bottom: 2px solid #b2b2b2;
            padding-left: 16px;
            padding-right: 16px;
            span[data-testid="deal-summary-item-details"] {
                    display: flex;
                    flex-direction: row-reverse;
                    font-weight: 600;
                }1
            `;
        }
        return `cursor: pointer;`;
    }}
`;

interface StyledDetailedSummarySectionProps {
    hasExpandableButtonStyles?: ComponentProps<typeof Grid>['sx'];
}

export const StyledDetailedSummarySection = styled.div<StyledDetailedSummarySectionProps>`
    ${({ hasExpandableButtonStyles }) => {
        return hasExpandableButtonStyles ? 'background-color: transparent;' : 'background-color: #f4f4f4;';
    }}
`;
